import React from "react";
import { OverlayView } from "@react-google-maps/api";
// import img from "src/assets/images/icons/truck.png";
import car from "src/assets/images/icons/carFront.png";
import carBlue from "src/assets/images/icons/carBlue.png";
// import car2 from "src/assets/images/icons/cartop2.png";

import "./InfoWindow.css";

const CustomMarker = ({
  position,
  heading,
  image,
  onClick,
  status,
  alertCountData,
  total_alert_count,
}) => {
  const getPixelPositionOffset = (width, height) => ({
    x: -(width / 2),
    y: -(height / 2),
  });

  return (
    <OverlayView
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      getPixelPositionOffset={getPixelPositionOffset}
    >
      <img
        src={image}
        alt=""
        className="w-3"
        onClick={onClick}
        style={{
          transform: `rotate(${heading || 0}deg)`,
          marginTop: "-25px",
        }}
      />
    </OverlayView>
  );

  // return (
  //   <OverlayView
  //     position={position}
  //     mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
  //     getPixelPositionOffset={getPixelPositionOffset}
  //   >
  //     <div
  //       className="map-marker-container"
  //       data-marker_id="4"
  //       // style={{ left: "228.75px", top: "64px" }}
  //       style={{ marinTop: "-25px !important" }}
  //       onClick={onClick}
  //     >
  //       <div className="marker-container">
  //         {/* <span className="marker-count">
  //           {alertCountData !== null ? alertCountData : 0}
  //         </span>
  //         {total_alert_count !== undefined ? (
  //           <span className="marker-count">{total_alert_count}</span>
  //         ) : (
  //           <span className="marker-count">
  //             {alertCountData !== null ? alertCountData : 0}
  //           </span>
  //         )} */}
  //         {total_alert_count !== undefined && total_alert_count > 0 && (
  //           <>
  //             <span className="marker-count">
  //               {alertCountData !== null ? alertCountData : 0}
  //             </span>
  //             {total_alert_count !== undefined ? (
  //               <span className="marker-count">{total_alert_count}</span>
  //             ) : (
  //               <span className="marker-count">
  //                 {alertCountData !== null ? alertCountData : 0}
  //               </span>
  //             )}
  //           </>
  //         )}
  //         <div
  //           className={`marker-card ${
  //             status === "vehicle-active"
  //               ? "marker-card-active"
  //               : "marker-card-inactive"
  //           }`}
  //         >
  //           <div
  //             className="marker-holder"
  //             style={{
  //               borderColor:
  //                 status === "vehicle-active" ? "#17f058" : "#f13c3c",
  //             }}
  //           >
  //             <img src={car} alt="" />
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </OverlayView>
  // );
};

export default CustomMarker;
